import React, { useEffect, useRef, useState } from 'react'

import {
  Card,
  Input,
  RadioGroup,
  Span,
  AutoCompleteInput,
  Grid,
  Col,
  CheckBox,
  Line,
  UnidadeGestoraFields,
  Picker
} from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { buildSetSize, getItemSize, ReportsRow } from 'components/ReportsRow'
import {
  useAuth,
  useDebounce,
  useLoading,
  useModal,
  useToggle,
  useWindowResize
} from 'hooks'
import moment, { Moment } from 'moment'
import { useHistory } from 'react-router-dom'
import jwt from 'jsonwebtoken'
import { VariableSizeList as List } from 'react-window'
import {
  IReportsCreModel,
  reportsDatabase
} from 'services/database/reportsDatabase'
import {
  ReportsCREServices,
  IRequestCards,
  IResponseCards
} from 'services/NGT/ReportsCRE'
import { UserCsnService, IGetCsnUserByResponse } from 'services/Supplier/Users'
import { COLORS, FORMAT, SPACING } from 'utils'

import { ButtonsRow } from './components'
import { IOnChangeUnidadeGestora } from 'components/UnidadeGestoraFields'
import { useForm } from 'react-hook-form'
import { boolean } from 'yup'

export interface IInputFields {
  analista: string
  cdContrato: string
  nmCentro: string
  nmEmpresa: string
  nmFornecedor: string
  nmSubcontratada: string
  cdMatricula: string
  periodoEntradaIni: Date | null
  periodoEntradaFim: Date | null
  competenciaDataIni: Date | Moment
  competenciaDataFim: Date | Moment
  flLiberado: string
  flPrescricao: string
  flDenuncia: string
  flDocPostado: string
}

interface IFillCard {
  id: number
  name: string
  checked?: boolean
  cdDocto?: string
}

interface IWindowingInfo {
  sizeMap: React.MutableRefObject<{}>
  ref: React.MutableRefObject<any>
}

interface IWindowingList {
  centros: IWindowingInfo
  contratos: IWindowingInfo
  empresas: IWindowingInfo
  fornecedores: IWindowingInfo
  subFornecedores: IWindowingInfo
}

interface ICheckLists {
  centros: IFillCard[]
  contratos: IFillCard[]
  empresas: IFillCard[]
  fornecedores: IFillCard[]
  subFornecedores: IFillCard[]
}

interface ICheckListsAll {
  centros: boolean
  contratos: boolean
  empresas: boolean
  fornecedores: boolean
  subFornecedores: boolean
}

interface IAutoComp {
  label: string
  value: IGetCsnUserByResponse
}

export const ReportsCRE: React.FC = () => {
  const { push, listen: historyListen } = useHistory()
  const { setLoading, setMsgErro } = useLoading()

  const historyListenerRef = useRef<() => void | null>(null)

  const REPORTS_PATHS = ['/ngt/relatorio-cre-resultado', '/ngt/relatorio-cre']

  const { showModal } = useModal()

  let verifyDate = false

  const DEFAULT_FIELDS: IInputFields = {
    analista: '',
    cdContrato: '',
    cdMatricula: '',
    competenciaDataFim: null,
    competenciaDataIni: null,
    flDenuncia: 'false',
    flLiberado: 'null',
    flPrescricao: 'null',
    nmCentro: '',
    nmEmpresa: '',
    nmFornecedor: '',
    nmSubcontratada: '',
    periodoEntradaFim: null,
    periodoEntradaIni: null,
    flDocPostado: 'null'
  }

  const DEFAULT_AUTOCOMP = [{ label: '', value: null }]

  const windowingInfo: IWindowingList = {
    centros: {
      ref: useRef(null),
      sizeMap: useRef({})
    },
    contratos: {
      ref: useRef(null),
      sizeMap: useRef({})
    },
    empresas: {
      ref: useRef(null),
      sizeMap: useRef({})
    },
    fornecedores: {
      ref: useRef(null),
      sizeMap: useRef({})
    },
    subFornecedores: {
      ref: useRef(null),
      sizeMap: useRef({})
    }
  }

  const [windowWidth] = useWindowResize()

  const contratosSetSize = buildSetSize(
    windowingInfo.contratos.sizeMap,
    windowingInfo.contratos.ref
  )
  const empresasSetSize = buildSetSize(
    windowingInfo.empresas.sizeMap,
    windowingInfo.empresas.ref
  )
  const centrosSetSize = buildSetSize(
    windowingInfo.centros.sizeMap,
    windowingInfo.centros.ref
  )
  const forenecedoresSetSize = buildSetSize(
    windowingInfo.fornecedores.sizeMap,
    windowingInfo.fornecedores.ref
  )
  const subcontradatasSetSize = buildSetSize(
    windowingInfo.subFornecedores.sizeMap,
    windowingInfo.subFornecedores.ref
  )

  const [fields, setFields] = useState<IInputFields>(DEFAULT_FIELDS)
  const [ignoreUpdateOn, setIgnoreUpdateOn] = useState<string | null>(null)
  const [checkLists, setCheckLists] = useState<ICheckLists>({
    centros: [],
    contratos: [],
    empresas: [],
    fornecedores: [],
    subFornecedores: []
  })
  const [checkListsAll, setCheckListsAll] = useState<ICheckListsAll>({
    centros: false,
    contratos: false,
    empresas: false,
    fornecedores: false,
    subFornecedores: false
  })

  const [refresh, setRefresh] = useState<boolean>(false)
  const [unidadeGestoraID, setUnidadeGestoraID] =
    useState<IOnChangeUnidadeGestora>({} as IOnChangeUnidadeGestora)
  const [matriculas, setMatriculas] = useState<IAutoComp[]>(DEFAULT_AUTOCOMP)
  const [selectedMatricula, setSelectedMatricula] = useState<any>()
  const [analistas, setAnalistas] = useState<IAutoComp[]>(DEFAULT_AUTOCOMP)
  const [selectedAnalita, setSelectedAnalista] = useState<any>()
  const [clearButton] = useState(false)
  const [isSuccess, toggleSucessModal] = useToggle()
  const [isError, toggleErrorModal] = useToggle()

  const refUnidGestora = useRef(null)

  const [changeEffect, toggleChangeEffect] = useToggle()
  const [lastContrato, setLastContrato] = useState<string | null>(null)
  const [checkSelecionado, setCheckSelecionado] = useState<Boolean>(false)
  const [checkValuesInput, setCheckValuesInput] = useState<Boolean>(false)

  const isFieldsEmpty = (fields: IInputFields): boolean => {
    return Object.values(fields).every(
      (value) =>
        value === '' ||
        value === null ||
        value === 'false' ||
        value === 'null' ||
        value === 'true'
    )
  }

  const hasValues = (checkLists: ICheckLists): boolean => {
    return (
      checkLists.centros.length > 0 ||
      checkLists.contratos.length > 0 ||
      checkLists.empresas.length > 0 ||
      checkLists.fornecedores.length > 0 ||
      checkLists.subFornecedores.length > 0
    )
  }

  const isMounted = useRef<boolean>(false)
  const { user } = useAuth()

  const validateDateValue = (value: Date | Moment | null): Date | Moment => {
    return moment(value).isValid() ? moment(value).toDate() : null
  }

  useEffect(() => {
    if (isFieldsEmpty(fields)) {
      setCheckValuesInput(false)
    } else {
      setCheckValuesInput(true)
      console.log('O objeto fields tem valores')
    }
    if (hasValues(checkLists)) {
      console.log('o objeto apareceu')
    } else {
      console.log('O objeto checklist não apareceu selecionado')
    }
    const isAnyCheckboxChecked = () => {
      const checkListsArray = [
        checkLists.centros,
        checkLists.contratos,
        checkLists.empresas,
        checkLists.fornecedores,
        checkLists.subFornecedores
      ]
      for (const list of checkListsArray) {
        if (list.some((checkList) => checkList.checked)) {
          return true
        }
      }
      return false
    }
    if (!isAnyCheckboxChecked()) {
      setCheckSelecionado(false)
    } else {
      setCheckSelecionado(true)
    }
  }, [fields, checkLists])

  useEffect(() => {
    setLoading('loading')
    reportsDatabase.cre
      .where({ id: 1 })
      .first()
      .then((reportCre) => {
        if (reportCre) {
          // setUnidadeGestoraID(reportCre.unidadeGestoraId)
          setCheckLists({
            centros: reportCre.centros.map((centro) => ({
              checked: centro.checked || false,
              id: centro.key,
              name: centro.value
            })),
            contratos: reportCre.contratos.map((contrato) => ({
              checked: contrato.checked || false,
              id: contrato.key,
              name: contrato.value
            })),
            empresas: reportCre.empresas.map((empresa) => ({
              checked: empresa.checked || false,
              id: empresa.key,
              name: empresa.value
            })),
            fornecedores: reportCre.fornecedores.map((fornecedor) => ({
              checked: fornecedor.checked || false,
              id: fornecedor.key,
              name: fornecedor.value,
              cdDocto: fornecedor.cdDocto
            })),
            subFornecedores: reportCre.subcontradatas.map((subcontradata) => ({
              checked: subcontradata.checked || false,
              id: subcontradata.key,
              name: subcontradata.value
            }))
          })

          setSelectedAnalista(reportCre.nmAnalista)
          setSelectedMatricula(reportCre.nmMatricula)

          setFields((oldState) => ({
            ...oldState,
            cdContrato: reportCre.cdContrato,
            analista: reportCre.nmAnalista,
            cdMatricula: reportCre.nmMatricula,
            competenciaDataFim: moment(reportCre?.competenciaFim).isValid()
              ? moment(reportCre?.competenciaFim)
              : null,
            competenciaDataIni: moment(reportCre?.competenciaInicio).isValid()
              ? moment(reportCre?.competenciaInicio)
              : null,
            flDenuncia: reportCre.denuncia,
            flLiberado: reportCre.flLiberado,
            flPrescricao: reportCre.flPrescricao,
            periodoEntradaFim: moment(reportCre.periodoEntradaFim).isValid()
              ? moment(reportCre.periodoEntradaFim).toDate()
              : null,
            periodoEntradaIni: moment(reportCre.periodoEntradaInicio).isValid()
              ? moment(reportCre.periodoEntradaInicio).toDate()
              : null,
            nmCentro: reportCre.centro,
            nmEmpresa: reportCre.empresa,
            nmFornecedor: reportCre.empresa,
            nmSubcontratada: reportCre.subcontratado
          }))
        }
        toggleChangeEffect()
      })
      .finally(() => setLoading('idle'))
  }, [])

  useEffect(() => {
    historyListenerRef.current = historyListen((location) => {
      if (!REPORTS_PATHS.includes(location.pathname)) {
        reportsDatabase.cre.delete(1)
        historyListenerRef?.current()
      }
    })
  }, [])

  useEffect(() => {
    if (changeEffect) {
      isMounted.current = true
    }
  }, [changeEffect])

  useEffect(() => {
    if (moment(fields?.periodoEntradaFim) < moment(fields?.periodoEntradaIni)) {
      verifyDate = true
      showModal({
        hideButtonCancel: true,
        message: 'Período Final é menor que o Período Inicial.',
        titleModal: 'Atenção',
        txtButtonConfirm: 'OK',
        type: 'alert'
      })
    }
  }, [fields?.periodoEntradaFim])

  const refreshGrid = (ignore = null): void => {
    setIgnoreUpdateOn(ignore)
    setRefresh((prevState) => !prevState)
  }

  const getIds = (from: string): [number] | [] => {
    if (!checkLists) return []

    return checkLists[from]?.flatMap((item: IFillCard) =>
      item.checked ? item.id : []
    )
  }

  const getAllFields = (): IRequestCards => {
    return {
      ...FORMAT.propIfExists({
        cdContrato: fields.cdContrato,
        cdMatricula: fields.cdMatricula,
        centrosIds: getIds('centros'),
        contratosIds: getIds('contratos'),
        empresasIds: getIds('empresas'),
        fornecedoresIds: getIds('fornecedores'),
        nmCentro: fields.nmCentro,
        nmEmpresa: fields.nmEmpresa,
        nmFornecedor: fields.nmFornecedor,
        nmSubcontratada: fields.nmSubcontratada,
        subcontratadasIds: getIds('subFornecedores')
      }),
      ...FORMAT.dateIfExists({
        competenciaDataFim: validateDateValue(fields.competenciaDataFim),
        competenciaDataIni: validateDateValue(fields.competenciaDataIni),
        periodoEntradaFim: validateDateValue(fields.periodoEntradaFim),
        periodoEntradaIni: validateDateValue(fields.periodoEntradaIni)
      }),
      ...FORMAT.propIfExists(
        {
          flDenuncia: fields.flDenuncia,
          flLiberado: fields.flLiberado,
          flPrescricao: fields.flPrescricao,
          flDocPostado: fields.flDocPostado
        },
        FORMAT.strToBoolOrNull
      ),
      ...(unidadeGestoraID
        ? { unidadeGestoraId: unidadeGestoraID }
        : {
          unidadeGestoraId: {
            Diretoria: null,
            DiretoriaExecutiva: null,
            Gerencia: null,
            GerenciaGeral: null
          }
        })
    }
  }

  const fillCardsExcept = (
    cardsData: IResponseCards,
    except: string = null
  ): void => {
    const {
      entity: { contratos, fornecedores, empresas, centros, subFornecedores }
    } = cardsData
    setCheckLists((prevState) => {
      const withException = {
        [except]: except ? prevState[except] : cardsData[except]
      }

      return {
        centros,
        contratos,
        empresas,
        fornecedores,
        subFornecedores,
        ...withException
      }
    })
  }

  const areDatesInvalid = (): boolean => {
    const isCompetenciaValido =
      (fields?.competenciaDataFim !== null &&
        !moment(fields.competenciaDataFim).isValid()) ||
      (fields?.competenciaDataIni !== null &&
        !moment(fields.competenciaDataIni).isValid())

    const isPeriodoValido =
      (fields?.periodoEntradaFim !== null &&
        !moment(fields.periodoEntradaFim).isValid()) ||
      (fields?.periodoEntradaIni !== null &&
        !moment(fields.periodoEntradaIni).isValid())

    return isPeriodoValido || isCompetenciaValido
  }

  const isEmpty = (obj) => Object.keys(obj).length === 0
  // GET CARDS
  const getFillCards = async (isClickIcon?: boolean) => {
    if (!isMounted.current) {
      return
    }

    if (areDatesInvalid()) {
      return
    }
    console.log('número de files' + fields)

    setLoading('loading')

    if (verifyDate != true) {
      try {
        const response = await ReportsCREServices(user).getCards(getAllFields())

        if (user?.PerfilUsuarioId == 6) {
          if (!response.data.sucesso) {
            setLoading('idle')
            showModal({
              hideButtonCancel: true,
              message:
                'O contrato que você esta tentando pesquisar na esta na sua grade de contraparte ou substituto no Sistema, para consultar contratos de outros contrapartes entrar em contrato com o NGT',
              txtButtonConfirm: 'OK',
              type: 'error'
            })
            toggleErrorModal()
          }
        }

        if (response.status !== 200) throw new Error('Erro obter dados.')
        if (isClickIcon) {
          setCheckLists({
            centros: response.data?.entity?.centros,
            contratos: response.data?.entity?.contratos,
            empresas: response.data?.entity?.empresas,
            fornecedores: response.data?.entity?.fornecedores,
            subFornecedores: response.data?.entity?.subFornecedores
          })
        } else {
          fillCardsExcept(response.data, ignoreUpdateOn)
        }

        setLoading('idle')
      } catch (error: any) {
        setLoading('error')
        setMsgErro('Erro ao obter dados do relatório')
      }
    } else {
      setLoading('idle')
    }
  }

  const resetPage = async () => {
    refreshGrid()

    if (user?.PerfilUsuarioId !== 6) refUnidGestora.current.clearForm()

    await reportsDatabase.cre
      .delete(1)
      .then()
      .finally(() => setLoading('idle'))
    push({ pathname: '/ngt/relatorio-cre' })
  }

  const persistToStorage = () => {
    const creModel: IReportsCreModel = {
      centros: checkLists.centros.map((checkList) => ({
        checked: checkList.checked || false,
        key: checkList.id,
        value: checkList.name
      })),
      cdContrato: fields.cdContrato,
      centro: fields.nmCentro,
      empresa: fields.nmEmpresa,
      fornecedor: fields.nmFornecedor,
      subcontratado: fields.nmSubcontratada,
      competenciaFim: moment(fields.competenciaDataFim)?.toDate(),
      competenciaInicio: moment(fields.competenciaDataIni)?.toDate(),
      contratos: checkLists.contratos.map((checkList) => ({
        checked: checkList.checked || false,
        key: checkList.id,
        value: checkList.name
      })),
      denuncia: fields.flDenuncia,
      empresas: checkLists.empresas.map((checkList) => ({
        checked: checkList.checked || false,
        key: checkList.id,
        value: checkList.name
      })),
      fornecedores: checkLists.fornecedores.map((checkList) => ({
        checked: checkList.checked || false,
        key: checkList.id,
        value: checkList.name,
        cdDocto: checkList.cdDocto
      })),
      id: 1,
      nmAnalista: fields.analista,
      nmMatricula: fields.cdMatricula,
      flPrescricao: fields.flPrescricao,
      periodoEntradaFim: validateDateValue(fields.periodoEntradaFim),
      periodoEntradaInicio: validateDateValue(fields.periodoEntradaIni),
      subcontradatas: checkLists.subFornecedores.map((checkList) => ({
        checked: checkList.checked || false,
        key: checkList.id,
        value: checkList.name
      })),
      flLiberado: fields.flLiberado,
      unidadeGestoraId: unidadeGestoraID
    }

    reportsDatabase.cre
      .where({ id: 1 })
      .first()
      .then((existsReport) => {
        if (existsReport) {
          reportsDatabase.cre.update(1, creModel)
        } else {
          reportsDatabase.cre.add(creModel)
        }
      })
  }

  const handleVisualizar = (action: string | null = null) => {
    if (
      'relatorio_completo' != action &&
      !checkSelecionado &&
      !checkValuesInput
    ) {
      showModal({
        message:
          'Nenhum dado foi selecionado. Deseja visualizar o relatório completo?',
        txtButtonConfirm: 'SIM',
        txtButtonCancel: 'NÃO',
        handleConfirm() {
          handleVisualizar('relatorio_completo')
        },
        type: 'alert',
        hideButtonCancel: false
      })
      return
    }
    setLoading('loading')
    persistToStorage()
    ReportsCREServices(user)
      .getEndResult(getAllFields())
      .then(({ data }) => {
        setLoading('idle')
        push({
          pathname: '/ngt/relatorio-cre-resultado',
          state: { allFields: getAllFields(), data: data }
        })
      })
      .catch(() => {
        // setMsgErro('Não foi possível visualizar')
        // setLoading('error')
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível visualizar',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFields((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value
    }))
  }

  const handleChangePeriod = (e, field: string) => {
    setFields((prevState) => ({
      ...prevState,
      [field]: e
    }))
  }

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIgnoreUpdateOn(null)
    setCheckSelecionado(false)
    setCheckValuesInput(false)
    handleInputChange(event)
  }

  const handleSearchMatricula = (event) => {
    setLoading('loading')
    UserCsnService()
      .getByMatricula(event.target.value)
      .then((response) => {
        const matriculas = response.data.map((matricula) => ({
          label: matricula.nmMatricula,
          value: matricula
        }))
        setMatriculas(matriculas)
        setLoading('idle')
      })
      .catch(() => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possivel obter o dados da pesquisa',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const handleSearchAnalista = (event) => {
    setLoading('loading')
    setAnalistas([])
    UserCsnService()
      .getByNome(event.target.value, event.target.value.includes('%'))
      .then((response) => {
        const analistas = response.data.map((analista) => ({
          label: analista.usuario.nmUsuario,
          value: analista
        }))
        setAnalistas(analistas)
        setLoading('idle')
      })
      .catch(() => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possivel obter o dados da pesquisa',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const handleSelectedValue = (value) => {
    setSelectedMatricula(value.nmMatricula)
    setSelectedAnalista(value.usuario?.nmUsuario)
    if (value === 0) {
      setFields((prev) => ({ ...prev, analista: '', cdMatricula: '' }))
      refreshGrid()
      return
    }
    setFields((prev) => ({ ...prev, analista: value?.usuario.nmUsuario || '' }))
    setFields((prev) => ({ ...prev, cdMatricula: value?.nmMatricula }))
    refreshGrid()
  }

  const handleCheck = (
    event: React.ChangeEvent<HTMLInputElement>,
    targetList: string,
    number: number = null
  ) => {
    const checked = event.target.checked
    const target = event.target.name

    setCheckLists((prevState) => ({
      ...prevState,
      [targetList]: prevState[targetList].map((item, index) => {
        if (item.name === target && (number === index || number === null)) {
          return { ...item, checked: checked }
        }
        return { ...item }
      })
    }))

    refreshGrid(targetList)
  }

  const handleCheckAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked
    const target = event.target.name

    setCheckLists((prevState) => ({
      ...prevState,
      [target]: prevState[target].map((item) => ({
        ...item,
        checked: checked
      }))
    }))

    setCheckListsAll((prevState) => ({
      ...prevState,
      [target]: checked
    }))

    refreshGrid()
  }

  const getCheckedAll = (target: string) => {
    if (!checkLists || !target) {
      return false
    }

    if (checkLists[target].length === 0) {
      return false
    }
    return checkLists[target].every((obj) => obj.checked)
  }

  useEffect(() => {
    if (isMounted.current) {
      if (clearButton) {
        return
      }

      getFillCards()
    }
  }, [
    refresh,
    fields.competenciaDataFim,
    fields.competenciaDataIni,
    fields.periodoEntradaFim,
    fields.periodoEntradaIni,
    fields.flLiberado,
    fields.flPrescricao,
    fields.flDenuncia,
    unidadeGestoraID
  ])

  return (
    <Card
      marginTop={SPACING.spacing20}
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      marginBottom={SPACING.spacing100}
      padding={SPACING.spacing20}
      boxShadow={`0 0 1em ${COLORS.lightGray}`}
    >
      <Grid
        gridCols="1fr 2fr 1.0fr 0.1fr 1.0fr 1.0fr 0.1fr 1.0fr"
        gridGap="0.8rem"
        margin="1rem 0 0 0"
      >
        <AutoCompleteInput
          marginTop={SPACING.spacing5}
          name="cdMatricula"
          onChangeText={useDebounce(handleSearchMatricula, 600)}
          value={selectedMatricula || null}
          options={matriculas || []}
          optionValue="label"
          label="Matrícula"
          onChange={(_, value) => handleSelectedValue(value)}
          valueName="value"
          noFilter
          maxLength={20}
        />
        <AutoCompleteInput
          name="analista"
          marginTop={SPACING.spacing5}
          onChangeText={useDebounce(handleSearchAnalista, 500)}
          value={selectedAnalita || null}
          options={analistas || []}
          optionValue="label"
          label="Analista"
          onChange={(_, value) => handleSelectedValue(value)}
          valueName="value"
          noFilter
          maxLength={100}
        />

        <Picker
          onChange={(e) => handleChangePeriod(e, 'periodoEntradaIni')}
          value={fields.periodoEntradaIni}
          maxDate={fields.periodoEntradaFim}
          label="Período de Entrada"
        />
        <Span text="à" fontSize="1rem" marginTop={SPACING.spacing30} />
        <Picker
          onChange={(e) => handleChangePeriod(e, 'periodoEntradaFim')}
          value={fields.periodoEntradaFim}
          minDate={fields.periodoEntradaIni}
          label=""
          marginLeft="-10px"
        />

        <Picker
          onChange={(e) => handleChangePeriod(e, 'competenciaDataIni')}
          value={fields.competenciaDataIni}
          maxDate={fields.competenciaDataFim || null}
          label="Competência"
          placeholder="mm/aaaa"
          views={['year', 'month']}
          inputFormat="MM/yyyy"
          type="monthAndYear"
          marginLeft={SPACING.spacing20}
        />
        <Span text="à" fontSize="1rem" marginTop={SPACING.spacing30} />
        <Picker
          onChange={(e) => handleChangePeriod(e, 'competenciaDataFim')}
          value={fields.competenciaDataFim}
          minDate={fields.competenciaDataIni || null}
          label=""
          placeholder="mm/aaaa"
          views={['month', 'year']}
          inputFormat="MM/yyyy"
          type="monthAndYear"
          marginLeft="-10px"
        />
      </Grid>

      <Grid gridCols="1fr 1fr" gridGap="1rem" margin="2rem 0 0 0">
        <Input
          formValue="cdContrato"
          label="Contrato"
          placeholder="Nº"
          value={fields.cdContrato}
          onChange={handleInputChange}
          inputIcon={<MagnifyingGlassIcon />}
          onClickIcon={() => getFillCards(true)}
          width="316px"
          marginBottom={SPACING.spacing10}
          maxLength={100}
        />
        <Input
          formValue="nmFornecedor"
          label="Fornecedor"
          placeholder="Nome do Fornecedor"
          value={fields.nmFornecedor}
          onChange={handleInputChange}
          inputIcon={<MagnifyingGlassIcon />}
          onClickIcon={() => getFillCards(true)}
          width="316px"
          marginBottom={SPACING.spacing10}
          maxLength={100}
        />
      </Grid>

      <Grid
        gridCols=".5fr .5fr"
        gridGap={`0 ${SPACING.spacing20}`}
        alignItems="flex-end"
        margin={`${SPACING.spacing20} 0 0 0`}
      >
      </Grid>
      <Grid
        gridCols=".5fr .5fr"
        gridGap={`0 ${SPACING.spacing20}`}
        alignItems="flex-end"
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
      >
        <Col>
          <CheckBox
            label="Marcar Todos"
            name="contratos"
            onChange={handleCheckAll}
            checked={getCheckedAll('contratos')}
            disabled={checkLists?.contratos?.length === 0}
          />
          <Card
            boxShadow="0px 0px 15px rgba(0, 0, 0, 0.25)"
            borderRadius="10px 10px"
            marginTop={SPACING.spacing15}
            marginBottom={SPACING.spacing15}
          >
            <Line />
            <List
              itemCount={checkLists.contratos.length}
              estimatedItemSize={30}
              itemSize={(index: number) =>
                getItemSize(windowingInfo.contratos.sizeMap, index)
              }
              ref={windowingInfo.contratos.ref}
              height={180}
              width="100%"
              useIsScrolling
            >
              {({ index, style }) => {
                return (
                  <div style={style} key={checkLists.contratos[index].id}>
                    <ReportsRow
                      index={index}
                      windowWidth={windowWidth}
                      setSize={contratosSetSize}
                    >
                      <CheckBox
                        name={checkLists.contratos[index].name}
                        onChange={(e) => handleCheck(e, 'contratos')}
                        checked={checkLists.contratos[index].checked}
                        label={checkLists.contratos[index].name}
                      />
                    </ReportsRow>
                  </div>
                )
              }}
            </List>
          </Card>
        </Col>
        <Col>
          <CheckBox
            label="Marcar Todos"
            name="fornecedores"
            onChange={handleCheckAll}
            checked={getCheckedAll('fornecedores')}
            disabled={checkLists?.fornecedores?.length === 0}
          />
          <Card
            boxShadow="0px 0px 15px rgba(0, 0, 0, 0.25)"
            borderRadius="10px 10px"
            marginTop={SPACING.spacing15}
            marginBottom={SPACING.spacing15}
          >
            <Line />
            <List
              itemCount={checkLists.fornecedores.length}
              estimatedItemSize={30}
              itemSize={(index: number) =>
                getItemSize(windowingInfo.fornecedores.sizeMap, index)
              }
              ref={windowingInfo.fornecedores.ref}
              height={180}
              width="100%"
              useIsScrolling
            >
              {({ index, style }) => {
                return (
                  <div style={style} key={checkLists.fornecedores[index].id}>
                    <ReportsRow
                      index={index}
                      windowWidth={windowWidth}
                      setSize={forenecedoresSetSize}
                    >
                      <CheckBox
                        name={checkLists.fornecedores[index].name}
                        onChange={(e) => handleCheck(e, 'fornecedores', index)}
                        checked={checkLists.fornecedores[index].checked}
                        label={
                          checkLists.fornecedores[index].name +
                          ' - ' +
                          FORMAT.formatCdDocto(
                            checkLists.fornecedores[index].cdDocto
                          )
                        }
                      />
                    </ReportsRow>
                  </div>
                )
              }}
            </List>
          </Card>
        </Col>
      </Grid>

      {/* CompanyCenter */}
      <Grid
        gridCols="1fr 1fr 1fr"
        gridGap="1rem"
        margin="1rem 0 0 0"
        alignItems="center"
      >
        <Input
          formValue="nmEmpresa"
          label="Empresa"
          placeholder="Nome do Empresa"
          value={fields.nmEmpresa}
          onChange={handleInputChange}
          inputIcon={<MagnifyingGlassIcon />}
          onClickIcon={() => getFillCards(true)}
          width="316px"
        />
        <Input
          formValue="nmCentro"
          label="Centro"
          placeholder="Nome do Centro"
          value={fields.nmCentro}
          onChange={handleInputChange}
          inputIcon={<MagnifyingGlassIcon />}
          onClickIcon={() => getFillCards(true)}
          width="316px"
        />
        <Input
          formValue="nmSubcontratada"
          label="Subcontratadas do Contrato"
          placeholder="Nome do Subcontratada"
          value={fields.nmSubcontratada}
          onChange={handleInputChange}
          inputIcon={<MagnifyingGlassIcon />}
          onClickIcon={() => getFillCards(true)}
          width="316px"
          marginBottom={SPACING.spacing10}
          maxLength={100}
        />
      </Grid>
      <Grid gridCols="1fr 1fr 1fr" gridGap="1rem" margin="1rem 0 1rem 0">
        <Col>
          <CheckBox
            label="Marcar Todos"
            name="empresas"
            onChange={handleCheckAll}
            checked={getCheckedAll('empresas')}
            disabled={checkLists?.empresas?.length === 0}
          />

          <Card
            boxShadow="0px 0px 15px rgba(0, 0, 0, 0.25)"
            borderRadius="10px 10px"
            marginTop={SPACING.spacing20}
          >
            <Line />
            <List
              itemCount={checkLists.empresas.length}
              estimatedItemSize={30}
              itemSize={(index: number) =>
                getItemSize(windowingInfo.empresas.sizeMap, index)
              }
              ref={windowingInfo.empresas.ref}
              height={180}
              width="100%"
              useIsScrolling
            >
              {({ index, style }) => {
                return (
                  <div style={style} key={checkLists.empresas[index].id}>
                    <ReportsRow
                      index={index}
                      windowWidth={windowWidth}
                      setSize={empresasSetSize}
                    >
                      <CheckBox
                        name={checkLists.empresas[index].name}
                        onChange={(e) => handleCheck(e, 'empresas')}
                        checked={checkLists.empresas[index].checked}
                        label={checkLists.empresas[index].name}
                      />
                    </ReportsRow>
                  </div>
                )
              }}
            </List>
          </Card>
        </Col>
        <Col>
          <CheckBox
            label="Marcar Todos"
            name="centros"
            onChange={handleCheckAll}
            checked={checkListsAll.centros}
            disabled={checkLists?.centros?.length === 0}
          />
          <Card
            boxShadow="0px 0px 15px rgba(0, 0, 0, 0.25)"
            borderRadius="10px 10px"
            marginTop={SPACING.spacing20}
          >
            <Line />
            <List
              itemCount={checkLists.centros.length}
              estimatedItemSize={30}
              itemSize={(index: number) =>
                getItemSize(windowingInfo.centros.sizeMap, index)
              }
              ref={windowingInfo.centros.ref}
              height={180}
              width="100%"
              useIsScrolling
            >
              {({ index, style }) => {
                return (
                  <div style={style} key={checkLists.centros[index].id}>
                    <ReportsRow
                      index={index}
                      windowWidth={windowWidth}
                      setSize={centrosSetSize}
                    >
                      <CheckBox
                        name={checkLists.centros[index].name}
                        onChange={(e) => handleCheck(e, 'centros')}
                        checked={checkLists.centros[index].checked}
                        label={checkLists.centros[index].name}
                      />
                    </ReportsRow>
                  </div>
                )
              }}
            </List>
          </Card>
        </Col>
        <Col>
          <CheckBox
            label="Marcar Todos"
            name="subFornecedores"
            onChange={handleCheckAll}
            checked={getCheckedAll('subFornecedores')}
            disabled={checkLists?.subFornecedores?.length === 0}
          />
          <Card
            boxShadow="0px 0px 15px rgba(0, 0, 0, 0.25)"
            borderRadius="10px 10px"
            marginTop={SPACING.spacing20}
          >
            <Line />
            <List
              itemCount={checkLists.subFornecedores.length}
              estimatedItemSize={30}
              itemSize={(index: number) =>
                getItemSize(windowingInfo.subFornecedores.sizeMap, index)
              }
              ref={windowingInfo.subFornecedores.ref}
              height={180}
              width="100%"
              useIsScrolling
            >
              {({ index, style }) => {
                return (
                  <div style={style} key={checkLists.subFornecedores[index].id}>
                    <ReportsRow
                      index={index}
                      windowWidth={windowWidth}
                      setSize={subcontradatasSetSize}
                    >
                      <CheckBox
                        name={checkLists.subFornecedores[index].name}
                        onChange={(e) => handleCheck(e, 'subFornecedores')}
                        checked={checkLists.subFornecedores[index].checked}
                        label={checkLists.subFornecedores[index].name}
                      />
                    </ReportsRow>
                  </div>
                )
              }}
            </List>
          </Card>
        </Col>
      </Grid>

      <Grid
        gridCols="1fr 1fr"
        gridGap={`0 ${SPACING.spacing20}`}
        alignItems="flex-start"
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
      >
        <Grid
          gridCols="1fr"
          gridGap={`0 ${SPACING.spacing20}`}
          alignItems="flex-end"
          margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
        >
          {user?.PerfilUsuarioId !== 6 && (
            <UnidadeGestoraFields
              gridCols={{
                Diretoria: 6,
                DiretoriaExecutiva: 6,
                Gerencia: 6,
                GerenciaGeral: 6,
                spacing: 2
              }}
              onChange={setUnidadeGestoraID}
              ref={refUnidGestora}
            />
          )}
        </Grid>
        {user?.PerfilUsuarioId !== 6 && (
          <Grid
            gridCols="1fr"
            gridGap={`0 ${SPACING.spacing20}`}
            alignItems="flex-end"
            margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
          >
            <Col marginBottom={SPACING.spacing5}>
              <RadioGroup
                label="Tipo"
                formValue="flLiberado"
                listOptions={[
                  { label: 'Liberado', value: 'true' },
                  { label: 'Bloqueado', value: 'false' },
                  { label: 'Total', value: 'null' }
                ]}
                value={fields.flLiberado}
                defaultValue={'null'}
                onChange={handleRadioChange}
                row
              />
            </Col>

            <Col marginBottom={SPACING.spacing5}>
              <RadioGroup
                label="Pendência"
                formValue="flPrescricao"
                listOptions={[
                  { label: 'Com Prescrição', value: 'true' },
                  { label: 'Sem Prescrição', value: 'false' },
                  { label: 'Total', value: 'null' }
                ]}
                value={fields.flPrescricao}
                defaultValue={'null'}
                onChange={handleRadioChange}
                row
              />
            </Col>

            <Col marginBottom={SPACING.spacing5}>
              {fields.flLiberado === 'true' ? (
                <RadioGroup
                  label="Doc. Postado"
                  formValue="flDocPostado"
                  listOptions={[
                    { label: 'Sim', value: 'true' },
                    { label: 'Não', value: 'false' },
                    { label: 'Todos', value: 'null' }
                  ]}
                  value={fields.flDocPostado}
                  defaultValue={'null'}
                  onChange={handleRadioChange}
                  row
                  disabled={true}
                />
              ) : (
                <RadioGroup
                  label="Doc. Postado"
                  formValue="flDocPostado"
                  listOptions={[
                    { label: 'Sim', value: 'true' },
                    { label: 'Não', value: 'false' },
                    { label: 'Todos', value: 'null' }
                  ]}
                  value={fields.flDocPostado}
                  defaultValue={'null'}
                  onChange={handleRadioChange}
                  row
                  disabled={false}
                />
              )}
            </Col>

            <Col marginBottom={SPACING.spacing5}>
              <RadioGroup
                label="Intervenção"
                formValue="flDenuncia"
                listOptions={[{ label: 'Denuncia', value: 'true' }]}
                defaultValue={'false'}
                value={fields.flDenuncia}
                onChange={handleRadioChange}
                row
              />
            </Col>
          </Grid>
        )}
      </Grid>

      <ButtonsRow
        resetPage={resetPage}
        handleVisualizar={handleVisualizar}
        disableImprimir={true}
      />
    </Card>
  )
}

export interface LocalStateReports {
  allCentros: boolean
  allContratos: boolean
  allEmpresas: boolean
  allFornecedores: boolean
  allSubContratos: boolean
}
